import { fetchProjectInfoAPI } from '@/api/projectInfo';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import logo from '@/assets/images/AURA_logo.png';
import '@/styles/pages/Changelog/ChangelogPage.scss';
import BasePaper from '@/components/ui/BasePaper';
import { useAppContext } from '@/provider/contexts';
import { ProjectInfoResponse } from '@/types/pages/projectInfo';
import { Box, CircularProgress, List } from '@mui/material';
import BaseTitle from '@/components/ui/BaseTitle';
import { DriveFileRenameOutline } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export default function ChangelogPage() {
    const [loading, setLoading] = useState(false);
    const [projectInfoData, setProjectInfoData] = useState<ProjectInfoResponse>({} as ProjectInfoResponse);
    const { setNotification } = useAppContext();

    const fetchProjectInfo = async () => {
        setLoading(true);
        const {
            data: { data, isSuccess, message },
        } = await fetchProjectInfoAPI();

        if (isSuccess) {
            setProjectInfoData(data);
        } else {
            setNotification({ message: message, severity: 'error' });
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchProjectInfo();
    }, []);
    const { t } = useTranslation('common');
    return (
        <>
            <BasePaper className="changelog-page-container">
                {loading ? (
                    <Box sx={{ mt: 6, display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Box>
                        <Box className="logo">
                            <img src={logo} alt={t('AURA Logo')} />
                        </Box>
                        <BaseTitle title={t('Change Log')} icon={<DriveFileRenameOutline />} />
                        <Box>
                            <List>
                                {projectInfoData?.information?.changelogs.map((changelog) => (
                                    <Box key={changelog.created_at}>
                                        <Box sx={{ fontWeight: 'bold', fontSize: '1.5rem' }}>
                                            {changelog.version_number} - {changelog.change_topic}
                                            <Box component={'span'} sx={{ fontWeight: 'normal', fontSize: '1rem' }}>
                                                {' '}
                                                - {dayjs(changelog.created_at).format('YYYY-MM-DD HH:mm:ss')}
                                            </Box>
                                        </Box>
                                        <Box>{changelog.change_type}</Box>
                                        <Box>{changelog.explanation}</Box>
                                    </Box>
                                ))}
                            </List>
                        </Box>
                    </Box>
                )}
            </BasePaper>
        </>
    );
}
